import React from 'react';
import * as S from './BookingCard.styles';

import BookingCardInfoHead from './BookingCardInfoHead/BookingCardInfoHead';
import BookingCardInfoDetails from './BookingCardInfoDetails/BookingCardInfoDetails';

const BookingCard = ({bookingDetail, navigateToMyTripsDetails}) => {
  return(
    <S.BookingCardMainWrap>
      <S.BookingCardOuterWrap>
        <S.BookingCardInnerWrap>
          <S.BookingCardHeaderWrap>
            <BookingCardInfoHead data={bookingDetail} navigateToMyTripsDetails={navigateToMyTripsDetails} />
          </S.BookingCardHeaderWrap>
          <S.BookingCardInfoWrap>
            <BookingCardInfoDetails data={bookingDetail} />
          </S.BookingCardInfoWrap>
        </S.BookingCardInnerWrap>
      </S.BookingCardOuterWrap>
    </S.BookingCardMainWrap>
  );
}

export default BookingCard;